import React,{useState} from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FavoriteIcon from '@material-ui/icons/Favorite';
import {Girl} from "./Inc";
import {Styles} from './Styles';

interface Props {
    girls:Girl[],
    isEnd:boolean,
    close():void,
}

const Happy = (props:Props)=> {
    const classes = Styles.base();
    const [mode,setMode] = useState("");
    let names:string[] = [];
    let count = "二人";
    if( props.girls.length===3 ){
        count = "三人";
    }
    for( let i=0 ; i<props.girls.length ; i++ ){
        names.push( props.girls[i].name );
    }
    const name = names.join("と");

    const check = ()=>{
        if( props.isEnd ){
            setMode("fin");
        } else {
            props.close();
        }
    }

    return (
        <div id="confirm" className={classes.dialogRoot}>
            {mode==="fin" ? (
            <React.Fragment>
                <div style={{textAlign:"center",padding:"1em 0"}}>
                    そしてあなただけが残った。<br/>
                </div>
                <FormControl fullWidth={true}>
                    <Button variant="contained" color="primary" onClick={props.close}>それから</Button>
                </FormControl>
            </React.Fragment>
            ):(
            <React.Fragment>
                <div style={{textAlign:"center",padding:"1em 0"}}>
                    {name}<br/>
                    {count}はなかよし<br/>
                    <FavoriteIcon style={{color:"pink"}}/><br/>
                </div>
                <FormControl fullWidth={true}>
                    <Button variant="contained" color="primary" onClick={check}>お幸せに</Button>
                </FormControl>
            </React.Fragment>
            )}
        </div>
    );
}

export default Happy;
